import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { Footer } from "../../Components/Footer/FooterComponent";
import SponsorForm from "../../Components/Patrocinadores/SponsorForm";
import { PublicidadSubNav } from '../../Components/Patrocinadores/PublicidadSubNav';

export const SponsorFormPage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <PublicidadSubNav tab="sponsor-admin" isAdmin showBackLink />
            <SponsorForm I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}
